<div class="card boxshadow">
  <div class="card-header bg-primary text-white text-center">
    Payment Requests
  </div>

  <div class="card-body">
    <div class="info-banner">
      <strong>Date: {{ todayDate }}</strong>
      <span class="cutoff">(Cut-off time is 3PM EST daily).</span>

      <div class="sub-text">
        Please verify that your payment has gone through by reloading the page once you are finished making changes.
      </div>
    </div>

    <br />

    <table id="tbldata"
           datatable
           [dtOptions]="dtOptions"
           class="row-border hover table table-striped table-bordered">
    </table>
  </div>
</div>
